// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"6a368b5d","141":"dfb58d7c","479":"068467d6","500":"b70b4c8e","613":"f613b9ac","637":"031be9bf","666":"2040248d","700":"13ad773c","744":"ad171d79","843":"03721baa","900":"f8ab18ae","955":"d0b45e3f","962":"b119918b"}[chunkId] + ".chunk.js";
};